import TermsStyles from "src/pages/terms/TermsStyles";

function Terms() {
  return (
    <TermsStyles>
      <header>
        <h1>Terms of Use</h1>
        <p>Last updated on 19 March 2025.</p>
      </header>
      <main>
        <section>
          <h2>Welcome to Telegram bot CY CamFines Bot!</h2>
          <p>
            These Terms of Use (hereinafter the “Terms”), consists of terms governing the relationship between us
            (hereinafter “the Service Provider”, “we,” “our”) and you (hereinafter the “User,” “you,” “your”) to your
            access to the Telegram bot CY CamFines Bot (hereinafter “CY CamFines Bot”).
            Please read these Terms carefully before accessing and using CY CamFines Bot. By accessing and using CY
            CamFines Bot, you represent that you understand, accept, and agree to be bound and comply with these Terms,
            Privacy Policy, and any rules, or modifications provided by the Service Provider that form the essential
            part of these Terms.
          </p>
          <p>
            IF YOU DO NOT AGREE WITH THESE TERMS OF USE, PLEASE DO NOT USE CY CAMFINES BOT AND THE SERVICES YOU RECEIVE
            THROUGH THE BOT.
          </p>
        </section>

        <section>
          <h2>GENERAL PROVISIONS</h2>
          <h3>Interpretation</h3>
          <p>
            The words of which the initial letter is capitalised have meanings defined under the following conditions.
            The following definitions shall have the same meaning regardless of whether they appear singular or plural.
          </p>
          <h3>Definitions</h3>
          <p>For the purposes of these Terms of Use:</p>
          <ul>
            <li>“CY CamFines Bot” or “Bot” refers to the Telegram bot CY CamFines Bot.</li>
            <li>“Service Provider” refers to Volodymyr Duchenchuk, the Bot’s developer, who operates CY CamFines Bot and
              offers the Services.
            </li>
            <li>“Services” shall mean the services the User receives through CY CamFines Bot.</li>
            <li>“Telegram” refers to the Telegram platform provided by Telegram Messenger Inc.</li>
            <li>“Terms of Use” or “Terms” shall mean these Terms, which, along with any other rules, or modifications
              provided by the Service Provider, form the entire agreement between the Service Provider and the User
              regarding using CY CamFines Bot and the Services.
            </li>
            <li>"Third-Party Sources" shall mean external databases, and other sources from external entities, such as
              government authorities or other organisations, that provide data or information used by the Bot, including
              but not limited to details on camera fines, car insurance, M.O.T., airbag recalls, and road tax status.
            </li>
            <li>“User” shall mean an individual or a company, or other legal entity on behalf of which such individual
              is accessing or using the CY CamFines Bot.
            </li>
          </ul>
          <h3>Acknowledgment</h3>
          <p>
            These Terms of Use govern your access to and use of CY CamFines Bot and the Services and form the agreement
            between you and the Service Provider. By accessing and using CY CamFines Bot and the Services, you
            acknowledge that your use is conditioned on your acceptance of and compliance with these Terms of Use.
          </p>
          <p>
            These Terms apply to all visitors, users, and others who access or use CY CamFines Bot and use the Services.
          </p>
          <p>
            You also acknowledge that your access to and use of CY CamFines Bot and Services is subject to your
            acceptance of and compliance with our Privacy Policy. Our Privacy Policy outlines the procedures for
            collecting, using, and disclosing your personal information when you use CY CamFines Bot. Please review our
            Privacy Policy carefully before using CY CamFines Bot and the Services.
          </p>
          <h3>Eligibility</h3>
          <p>
            To use CY CamFines Bot and the Services, you represent and warrant that you are at least eighteen (18) years
            old or have the right, authority, and capacity to enter into these Terms, to accept these Terms and to abide
            by all of their terms and conditions.
          </p>
          <p>
            If you are accessing CY CamFines Bot and the Services on behalf of a company, entity, or organisation
            (collectively, the “entity”), you represent and warrant that: (i) you are an authorised representative of
            the entity with authority to bind it to these Terms; (ii) you have read and understood these Terms; and
            (iii) you agree to these Terms on behalf of the entity. All references to “you” in these Terms of Use also
            refer to that entity.
          </p>
          <h3>Changes to these Terms of Use</h3>
          <p>
            We reserve the right, at our sole discretion, to change, update, modify, supplement, or replace these Terms
            of Use at any time to improve the quality of CY CamFines Bot's features and comply with legal requirements.
            The new version of the Terms enters into force when it is posted via our Bot within the Telegram app.
          </p>
          <p>
            We will post a notice via our Bot within the Telegram app to inform you of any essential changes at least
            fifteen (15) days before they come into force, but it is your responsibility to review the notice and be
            aware of any such changes.
          </p>
          <p>
            By continuing to access or use CY CamFines Bot and the Services after those revisions become effective,
            shall mean your acceptance of any such changes, whether given notice or not. If you do not agree to the new
            terms, in whole or in part, please stop using CY CamFines Bot and the Services.
          </p>
          <h3>Availability</h3>
          <p>
            We may, at our sole and absolute discretion and without liability, at any time and without notice, modify
            the Bot in any way we deem necessary.
          </p>
          <p>
            The information, features, and materials available through CY CamFines Bot are subject to modification,
            removal, or discontinuation at the sole discretion of the Service Provider, without prior notice. You
            acknowledge and agree that such changes may impact the use and functionality of the Bot.
          </p>
          <p>
            You agree that the Service Provider will not be held liable for any loss or inconvenience arising from the
            modification, removal, discontinuation, restriction, or unavailability of the Bot or its features, whether
            temporary or permanent, and regardless of the reason for such changes.
          </p>
          <p>
            The Service Provider reserves the right to cease all operations on the Telegram app and discontinue CY
            CamFines Bot at any time. Should you lose access to the Bot or some of its features for any reason, the
            Service Provider will not be liable for any costs, losses, or damages incurred. Potential reasons for the
            loss of access include, but are not limited to:
          </p>
          <ul>
            <li>(i) technical errors;</li>
            <li>(ii) the Service Provider no longer maintains the Bot;</li>
            <li>(iii) Telegram no longer supporting certain features integrated by the Bot;</li>
            <li>(iv) restrictions or bans on Telegram, preventing access to the Telegram platform or its features, due
              to government regulations, security concerns, or other legal reasons, resulting in the Bot losing access;
            </li>
            <li>(v) restrictions imposed by Telegram on your account or specific regions in accordance with current
              demand, technological limitations, economic considerations, regulatory restrictions and other factors;
            </li>
            <li>(v) accidental or intentional deletion of the Bot by the Service Provider;</li>
            <li>(vi) external factors beyond the control of the Service Provider.</li>
          </ul>
        </section>

        <section>
          <h2>WHAT IS CY CAMFINES BOT</h2>
          <p>
            CY CamFines Bot is an independent service that automatically notifies you of any new camera fines for your
            vehicles and checks your car insurance, M.O.T., airbag recall, and road tax status.
          </p>
          <p>
            CY CamFines Bot retrieves publicly available information from the Third-Party Sources, namely:
          </p>
          <ul>
            <li>information related to road tax, car insurance, and MOT status is retrieved from the official website of
              the Cyprus Department of Road Transport available at <a
                href="https://rtd.mcw.gov.cy/">https://rtd.mcw.gov.cy/</a>;
            </li>
            <li>penalty data, including fines and related information, is retrieved from the Cyprus Camera System
              available at <a href="https://cycamerasystem.com.cy/">https://cycamerasystem.com.cy/</a>;
            </li>
            <li>detailed data on penalties, including penalty points, fees, and offender details, is retrieved from the
              JCC Smart Platform available at <a href="https://www.jccsmart.com/">https://www.jccsmart.com/</a>;
            </li>
            <li>other external resources related to the Bot’s features.</li>
          </ul>
          <p>
            CY CAMFINES BOT IS NOT AN OFFICIAL SERVICE OF THE CYPRUS AUTHORITIES AND IS NOT AFFILIATED WITH OR ENDORSED
            BY ANY GOVERNMENT AGENCY.
          </p>
          <p>
            CY CAMFINES BOT is provided for informational purposes only and should not be considered a legally binding
            source for fines or vehicle-related obligations. By using the Services, you acknowledge and agree that the
            data retrieved from the Third-Party Sources and provided through the Bot is for informational purposes only
            and is sourced directly from the respective publicly available Third-Party Sources. The Service Provider
            does not control or modify this data and cannot guarantee the accuracy, completeness, or timeliness of the
            information provided. If any Third-Party Sources experience downtime or errors, the Bot may also be
            affected.
          </p>
          <h3>2.1. The Bot’s features</h3>
          <p>
            When you use CY CamFines Bot you can be able to:
          </p>
          <ul>
            <li>familiarise yourself with the information for your vehicle:</li>
            <li>any new camera fines;</li>
            <li>M.O.T. (done or not);</li>
            <li>car insurance (absence or not);</li>
            <li>road tax (paid or not, and time until it works);</li>
            <li>tickets for a vehicle if any (date of violation, ticket amount, penalty points);</li>
            <li>check information for up to seven (7) vehicles simultaneously.;</li>
            <li>renew a road tax using the <a
              href="https://rtd.mcw.gov.cy/WebPhase1/RoadTaxLicenceRenewal/LicenceRenewalServlet?lang=en">https://rtd.mcw.gov.cy/WebPhase1/RoadTaxLicenceRenewal/LicenceRenewalServlet?lang=en</a> link;
            </li>
            <li>proceed to the fine payment (if any) using the JCC Smart Platform link;</li>
            <li>choose the desired language of CY CamFines Bot interface;</li>
            <li>use other available functions of the Bot.</li>
          </ul>
          <h3>2.2. Access</h3>
          <p>
            The use of CY CamFines Bot functionality is only available after registration. There is no registration
            payment. Access to the Bot’s features is free.
          </p>
          <p>
            In order to use CY CamFines Bot and to access the features of the Bot you need to create your personal
            account. To be able to check the information for your vehicle on your behalf, we would need some of your
            personal information such as a vehicle plate number or identification document type (Alien Registration
            Certificate number (ARC), Passport, Cypriot ID, Company number). You can track the information for up to
            seven (7) vehicles simultaneously. You can remove and add vehicles, but the total number of vehicles cannot
            exceed seven (7) at any given time.
          </p>
          <p>
            You must provide accurate and complete information to register for an account to use our Services. You have
            the right to grant access to your account to third parties; however, you are fully responsible for
            maintaining the confidentiality of your personal information and account credentials. Furthermore, you are
            also liable for any activities that occur under your account. In the event of unauthorised use of your
            account or any security breach, you must immediately notify the Service Provider.
          </p>
          <h3>Deletion of the account</h3>
          <p>
            If you want to delete your account or stop using CY CamFines Bot, you must follow the procedure provided by
            Telegram.
          </p>
          <p>
            You can block or delete your account through the Telegram app or website. Besides, you are allowed to view,
            download or delete all personal data in your account within the Bot interface.
          </p>
          <p>
            The Service Provider may choose to deactivate or delete the Bot at their sole discretion. The Service
            Provider can stop CY CamFines Bot that involves disabling the Bot or removing access to it. The Bot can be
            deleted entirely from the Telegram servers. This deletion removes the Bot’s access to Telegram servers,
            meaning it will no longer be able to interact with Users.
          </p>
        </section>

        <section>
          <h2>USE OF THE BOT. PROHIBITED ACTIVITIES</h2>
          <h3>Warranties</h3>
          <p>
            You warrant that all information provided during interactions with the Bot (such as personal details,
            vehicle information, or any other data) is true, accurate, and not misleading.
          </p>
          <p>
            You warrant that you will not impersonate any other person or entity, whether actual or fictitious, when
            using CY CamFines Bot and Services, or defame or otherwise harm the Service Provider, other Users or any
            other third party through your use of the Bot and the Services.
          </p>
          <p>
            By using the Bot, you agree to comply with all relevant national and international laws, including, but not
            limited to, data protection laws (such as GDPR or any relevant local regulations) when using the Bot. This
            includes ensuring that no illegal activities are undertaken, and that the Bot is not used to gather or
            misuse data in violation of privacy or intellectual property rights.
          </p>
          <h3>Grant of Authorisation for Data Access</h3>
          <p>
            By using the CY CamFines Bot, you explicitly authorise the Bot to make server requests on your behalf and
            retrieve information related to your vehicle data from third-party sources, such as the Department of Road
            Transport of the Republic of Cyprus, the Cyprus Camera System, the JCC Smart Platform, or any other
            third-party service that provides information on traffic violations in Cyprus and related to the Bot’s
            features. You grant permission for CY CamFines Bot to obtain this data on your behalf by providing the
            relevant personal identification data as requested by the Bot. This data is strictly accessible only to the
            Bot itself and is used solely for the purposes of checking outstanding camera fines, car insurance, M.O.T.,
            airbag recalls, and road tax status through the Bot.
          </p>
          <p>
            You understand and acknowledge that:
          </p>
          <ul>
            <li>the Bot will request, retrieve, and display information only as provided from the Third-Party Sources,
              and the Service Provider owner is not responsible for the accuracy, completeness, or timeliness of the
              data retrieved;
            </li>
            <li>you have the right to revoke this authorisation at any time by ceasing to use CY CamFines Bot.</li>
          </ul>
          <h3>Prohibited activities</h3>
          <p>
            You agree that you will not use СY CamFines Bot and the Services to (not attempt to):
          </p>
          <ul>
            <li>perform any activities that intentionally or unintentionally violate any applicable local, state,
              national or international law, regulation, or violate these Terms or any other policy or rules;
            </li>
            <li>use the Bot for fraudulent, deceptive, or illegal purposes, that includes, but is not limited to,
              attempting to access the Services through unauthorised means, using the Bot to carry out any form of
              identity theft, fraud, or other illegal activities;
            </li>
            <li>use the Bot for any form of spamming, unsolicited marketing, or harassment that includes but is not
              limited to sending unsolicited messages to other Users or repeatedly interacting with the Bot in an
              abusive or disruptive manner;
            </li>
            <li>impersonate any individual or entity, including but not limited to, other Users, or any government or
              business entity;
            </li>
            <li>use the Bot for scraping, extracting, or harvesting data for any unauthorised or unlawful purpose that
              includes any attempt to collect data, including personal data, without the consent of the Service Provider
              or the individuals involved;
            </li>
            <li>gain unauthorised access to any part of the Bot, its systems, or its data that includes hacking
              attempts, exploiting vulnerabilities, or circumventing the Bot's security mechanisms in any way, including
              bypassing CAPTCHA or other security measures;
            </li>
            <li>distribute viruses, malware, or any other form of harmful software or code that could damage or disrupt
              the Bot’s functionality, other Users’ devices, or systems;
            </li>
            <li>use automated tools, scripts, or bots to interact with the Bot without prior consent from the Service
              Provider, that may include the use of any form of automation that could overload, disrupt, or negatively
              impact the performance of the Bot;
            </li>
            <li>upload, post, or distribute any content that infringes upon the intellectual property rights of others,
              use copyrighted materials without permission, share proprietary information without authorisation, or
              engage in any activity that violates copyright, trademark, or patent laws;
            </li>
            <li>use the Bot to post, share, or otherwise distribute content that is obscene, offensive, threatening,
              abusive, defamatory, discriminatory, or otherwise harmful to others.
            </li>
            <li>use the Bot or any of its parts for any commercial purpose without obtaining the Service Provider’s
              prior written consent.
            </li>
          </ul>
        </section>

        <section>
          <h2>INTELLECTUAL PROPERTY RIGHTS</h2>
          <h3>Ownership</h3>
          <p>
            The Service Provider retains ownership over the code of the Bot, the features of the Bot, the Services it
            offers, trademarks, architecture, protocols and any copyrighted materials accessed via the Bot.
          </p>
          <p>
            All intellectual property and means of individualisation present via the Bot, and related to Services are
            protected by copyright law, trademark law, and other applicable laws. By using the Bot, or any Services
            provided, you do not acquire any rights to own any intellectual property.
          </p>
          <p>
            Without the Service Provider's prior written consent, you are prohibited from copying, reproducing,
            distributing, or using any intellectual property on the Bot. Unauthorised use of any intellectual property
            for any purpose is strictly prohibited.
          </p>
          <p>
            Neither these Terms nor the User's use of the Bot grants you any rights to the Bot, or related Services,
            except for the limited licence granted below, nor does it grant you any right to use or reference the
            Service Provider’s trademarks, logos, brand names, service marks, or similar marks.
          </p>
          <h3>4.2. Licence</h3>
          <p>
            Subject to your compliance with these Terms, the Service Provider grants you a limited, personal,
            non-exclusive, non-transferable, revocable, non-sublicensable licence to use the Bot, and the Services
            solely for personal use to access and use the information provided. Any rights not expressly granted herein
            are reserved by the Service Provider and other licensors.
          </p>
          <p>
            You may not sell, distribute, reproduce, transmit, publicly demonstrate, translate, modify, adapt, create
            derivative works, disassemble, reverse engineer, decompile, lease, borrow, sublicense or otherwise use the
            Bot, the Services, content, trademarks, and any other intellectual property without the prior written
            permission of the Service Provider or other licensors.
          </p>
        </section>

        <section>
          <h2>WARRANTIES, LIABILITIES, INDEMNITY</h2>
          <h3>WARRANTY DISCLAIMERS</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE BOT AND THE SERVICES ARE PROVIDED BY US ON “AS IS”
            AND “AS AVAILABLE” BASIS, THAT MEANS AS YOU SEE THEM NOW AND WHICH ARE AVAILABLE TO YOU.
          </p>
          <p>
            WE MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED:
          </p>
          <ul>
            <li>AS TO THE OPERATION OR AVAILABILITY OF THE SERVICES, OR THE INFORMATION, CONTENT, AND MATERIALS OR
              PRODUCTS INCLUDED THEREON;
            </li>
            <li>THAT THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, OR THAT ANY ERRORS OR DEFECTS CAN OR WILL BE
              CORRECTED;
            </li>
            <li>AS TO THE ACCURACY, RELIABILITY, OR CURRENCY OF ANY INFORMATION OR CONTENT PROVIDED THROUGH THE
              SERVICES;
            </li>
            <li>CORRESPONDENCE OF THE SERVICES TO YOUR EXPECTATIONS.</li>
          </ul>
          <p>
            WITHOUT LIMITATION TO THE FOREGOING, WE PROVIDE NO WARRANTY OR UNDERTAKING, AND MAKES NO REPRESENTATION OF
            ANY KIND THAT THE BOT OR THE SERVICES WILL MEET YOUR REQUIREMENTS, ACHIEVE ANY INTENDED RESULTS, BE
            COMPATIBLE OR WORK WITH ANY OTHER SOFTWARE, APPLICATIONS, SYSTEMS OR SERVICES, WILL COMPLY WITH ANY
            PERFORMANCE OR RELIABILITY STANDARDS.
          </p>
          <p>
            CY CAMFINES BOT DOES NOT GENERATE OR MODIFY DATA—IT ONLY RETRIEVES AND PRESENTS INFORMATION FROM THIRD-PARTY
            SOURCES. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY, COMPLETENESS, OR TIMELINESS,
            DISCREPANCIES, ERRORS, OR OMISSIONS IN THE DATA PROVIDED THROUGH THE BOT AND DATA UPDATES. ALWAYS VERIFY
            IMPORTANT INFORMATION DIRECTLY THROUGH OFFICIAL SOURCES.
          </p>
          <h3>LIMITATION OF LIABILITY</h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW THE SERVICE PROVIDER SHALL NOT BE LIABLE FOR ANY INDIRECT,
            INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUE, WHETHER INCURRED
            DIRECTLY OR INDIRECTLY, OR FOR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM
            (I) THE USE OR INABILITY TO USE THE BOT, (II) ANY THIRD-PARTY ACTIONS RELATED TO THE DATA RETRIEVED THROUGH
            THE BOT, OR (III) ANY UNAUTHORISED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA.
          </p>
          <p>
            NO INFORMATION YOU OBTAIN FROM THROUGH THE BOT SHALL CREATE ANY WARRANTY OR REPRESENTATION NOT EXPRESSLY
            STATED IN THESE TERMS. THE SERVICE PROVIDER HAS NO LIABILITY FOR ANY FAILURE OR DELAY RESULTING FROM ANY
            REASON BEYOND THE SERVICE PROVIDER’S REASONABLE CONTROL.
          </p>
          <p>
            BY USING CY CAMFINES BOT, YOU AGREE THAT:
          </p>
          <ul>
            <li>WE ARE NOT RESPONSIBLE FOR THE ACCURACY, COMPLETENESS, OR TIMELINESS OF THE DATA PROVIDED THROUGH THE
              BOT AND DATA UPDATES;
            </li>
            <li>WE ARE NOT RESPONSIBLE FOR ANY INCORRECT, DELAYED, OR MISSING NOTIFICATIONS;</li>
            <li>WE ARE NOT LIABLE FOR ANY AMOUNTS OF FINES, PENALTIES, OR LEGAL CONSEQUENCES YOU FIND OUT FROM RELIANCE
              ON THE BOT’S INFORMATION RETRIEVED FROM THIRD-PARTY SOURCES;
            </li>
            <li>THE BOT DOES NOT REPLACE OFFICIAL NOTIFICATIONS SENT BY CYPRUS AUTHORITIES (SUCH AS LETTERS OR
              EMAILS);
            </li>
            <li>USE OF THIS BOT IS AT YOUR OWN RISK.</li>
          </ul>
          <p>
            BY USING CY CAMFINES BOT, YOU ACKNOWLEDGE AND AGREE THAT THE SERVICE PROVIDER DOES NOT TAKE RESPONSIBILITY
            FOR ANY FURTHER ACTIONS THAT YOU, AS THE USER, MAY UNDERTAKE WITH THE DATA OBTAINED THROUGH THE BOT’S
            SERVICES. THIS INCLUDES, BUT IS NOT LIMITED TO, THE USE, STORAGE, OR SHARING OF PERSONAL, VEHICLE-RELATED,
            OR FINE-RELATED INFORMATION GATHERED FROM THIRD-PARTY SOURCES VIA THE BOT. THE SERVICE PROVIDER IS NOT
            LIABLE FOR ANY CONSEQUENCES, DAMAGES, OR LOSSES THAT MAY ARISE FROM YOUR USE OF, OR RELIANCE ON, ANY DATA
            PROVIDED BY THE BOT, INCLUDING BUT NOT LIMITED TO FINES, PENALTIES, VEHICLE STATUS, OR OTHER PERSONAL
            INFORMATION.
          </p>
          <p>
            YOU ACKNOWLEDGE THAT AS NO FEES ARE PAID BY YOU TO US FOR THE SERVICES, NOTWITHSTANDING ANY DAMAGES THAT YOU
            MIGHT INCUR, THE ENTIRE LIABILITY OF THE SERVICE PROVIDER FOR ALL DAMAGES, LOSSES, AND CAUSES OF ACTION IN
            CONNECTION WITH THE USE OF THE BOT AND THE SERVICES SHALL BE LIMITED TO INJUNCTIVE RELIEF ONLY, UNLESS
            OTHERWISE PERMITTED BY LAW, AND YOU SHALL NOT BE ENTITLED TO DAMAGES OF ANY KIND FROM US, REGARDLESS OF THE
            CAUSE OF ACTION.
          </p>
          <p>
            THE SERVICE PROVIDER IS NOT AND SHALL NOT BE RESPONSIBLE FOR:
          </p>
          <ul>
            <li>YOUR LOSS OF OR INABILITY TO USE THE BOT AND THE SERVICES, AS WELL AS YOUR NEED TO MAKE AMENDMENTS TO
              YOUR BEHAVIOUR AS A RESULT OF CHANGES TO THESE TERMS;
            </li>
            <li>ACTIONS OR INACTIONS OF OTHER USERS AND THIRD PARTIES.</li>
          </ul>
          <p>
            THE SERVICE PROVIDER SHALL NOT BE LIABLE FOR ANY FAILURE OR DELAY IN THE PERFORMANCE OF ITS OBLIGATIONS
            UNDER THESE TERMS OF USE DUE TO FORCE MAJEURE CIRCUMSTANCES THAT IS BEYOND ITS REASONABLE CONTROL, INCLUDING
            BUT NOT LIMITED TO ACTS OF GOD, WAR, TERRORISM, STRIKES, EMBARGOES, GOVERNMENT ORDERS, OR ANY OTHER FORCE
            MAJEURE CIRCUMSTANCES.
          </p>
          <h3>INDEMNITY</h3>
          <p>
            To the extent permitted by law, you agree to indemnify, defend, and hold harmless the Service Provider,
            affiliates, agents, and contractors from and against any claims, damages, liabilities, costs, and expenses
            (including reasonable attorney fees) arising out of or related to (i) your use of the Bot and the Services,
            (ii) your breach of these Terms of Use, or (iii) any violation of applicable laws or regulations.
          </p>
        </section>

        <section>
          <h2>MISCELLANEOUS PROVISIONS</h2>
          <h3>Applicable Law</h3>
          <p>
            All matters relating to СY CamFines Bot and the Services, these Terms and your use of the Services shall be
            governed by the laws of the Republic of Cyprus without regard to legal conflict provisions.
          </p>
          <h3>Dispute Resolution</h3>
          <p>
            If you have any questions regarding these Terms or certain disagreements, claims, or disputes (hereinafter —
            the “Disputes”) that affect the use of the Bot or the Services, you agree to first try to resolve the
            Dispute informally by contacting the Service Provider. We will use reasonable efforts to resolve such
            Disputes through negotiation.
          </p>
          <p>
            All Disputes arising in connection with these Terms that cannot be resolved by negotiation shall be settled
            by the appropriate courts of the Republic of Cyprus.
          </p>
          <h3>Severability and Waiver</h3>
          <p>
            These Terms supersede all prior agreements, discussions, and proposals related to the Bot and the Services,
            and represent the complete agreement between you and us regarding access to and use of the Bot and the
            Services unless stated otherwise in these Terms.
          </p>
          <p>
            If any provision of these Terms is found to be unenforceable or invalid, that provision will be modified and
            interpreted in a way that best achieves its original intent within the limits of applicable law, while the
            remaining provisions will remain in full effect.
          </p>
          <p>
            Unless explicitly stated otherwise in these Terms, the failure to exercise any right or demand performance
            of any obligation under these Terms will not prevent a party from exercising that right or demanding
            performance in the future, nor will the waiver of a breach be considered a waiver of any future breaches.
          </p>
          <h3>Third-Party Sources and External Links</h3>
          <p>
            СY CamFines Bot may provide access to the Third-Party Sources through links or integrated features. External
            links provided through the Bot are for the User’s convenience only (to update information, pay a fine,
            etc.). The Service Provider does not control and is not responsible for the content, terms, privacy
            policies, or practices of these Third-Party Sources. By using the Bot, you acknowledge and agree that the
            Service Provider is not responsible for any loss or damage incurred as a result of your interactions with
            the Third-Party Sources.
          </p>
          <p>
            We strongly advise you to read the terms and conditions and privacy policies of any Third-Party Sources that
            you visit.
          </p>
          <h3>Feedback, reviews, and complaints</h3>
          <p>
            By using the CY CamFines Bot, you acknowledge and agree that you may be invited to provide feedback,
            reviews, or complaints regarding the Bot's functionality and your experience. You are solely responsible for
            the content and accuracy of your reviews, feedback, and complaints. All information provided must be true,
            accurate, and not misleading.
          </p>
          <p>
            We are not responsible for handling or resolving any complaints related to the information retrieved from
            the Third-Party Sources through the Bot. For any official matters or disputes, you should address them
            directly with the relevant government-authorised entities.
          </p>
          <h3>Term and Termination</h3>
          <p>
            These Terms will survive and operate as long as you continue to access the Bot and the Services or use them.
          </p>
          <p>
            We reserve the right to suspend or terminate your access to the Bot and the Services at any time without
            notice if we determine that you violate these Terms, use the Bot for fraudulent, abusive, or unauthorised
            purposes, interfere with or disrupt the Bot’s functionality.
          </p>
          <p>
            All provisions of these Terms which by their nature should survive termination shall survive termination,
            including but not limited to disclaimers of warranties and limitations of liability.
          </p>
          <h3>Contact Details</h3>
          <p>
            If you have a question related to these Terms of use or your use of CY CamFines Bot and the Services, you
            can use the following details to contact us:
          </p>
          <p>
            Service Provider: Volodymyr Duchenchuk<br/>
            Email: <a href="mailto:cycamfinesbot@gmail.com">cycamfinesbot@gmail.com</a>
          </p>
        </section>
      </main>
    </TermsStyles>
  );
}

export default Terms;
